import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import toast, { Toaster } from 'react-hot-toast'
import { Link, useSearchParams } from 'react-router-dom'
import * as yup from 'yup'
import MainButton from '../../components/buttons/mainButton/MainButton'
import Field from '../../components/textField/Field'
import { translations } from '../../configs/translations'
import UserService from '../../services/UserService'
import { useStore } from '../../store/store'
import './Register.css'

const Register = () => {
    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];
    const [searchParams] = useSearchParams();
    const storedPlayerId = localStorage.getItem('gameId');
    const playerId = Number(searchParams.get('playerId') || storedPlayerId || -1);
    const register = useStore(state => state.register);

    type FormData = yup.InferType<typeof schema>;

    const schema = yup.object({
        username: yup
            .string()
            .required(t.username_required)
            .min(3, t.user_must_be_between_4_and_20_characters)
            .max(20, t.user_must_be_between_4_and_20_characters),
        email: yup
            .string()
            .required(t.email_required)
            .email(t.email_invalid),
        password: yup
            .string()
            .required(t.password_required)
            .min(8, t.password_must_be_at_least_8_characters)
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,}$/,
                t.password_pattern
            )
    });    

    const {
        register: registerField,
        handleSubmit,
        formState: { errors },
        watch
    } = useForm<FormData>({
        resolver: yupResolver(schema),
        mode: 'onChange'
    });

    const onSubmit = async (data: FormData) => {
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const { ip } = await ipResponse.json();      

        await register(data.username, data.email, data.password, playerId, ip)
            .then(async () => {
                await UserService.openLobby()
                    .catch((error) => {
                        toast.error(
                            error && error.response && error.response.data && t[error.response.data as keyof typeof t] 
                                ? t[error.response.data as keyof typeof t] 
                                : t.error_unknown,
                            { className: 'notification-error' }
                        );
                    });
            })
            .catch((error) => {
                toast.error(
                    error && error.response && error.response.data && t[error.response.data as keyof typeof t] 
                        ? t[error.response.data as keyof typeof t] 
                        : t.error_unknown,
                    { className: 'notification-error' }
                );
            });
    };

    const username = watch('username');
    const email = watch('email');
    const password = watch('password');

    return (
        <div className="container">
            <div className="window">

                <h1 className='title'>{t.signup}</h1>
                <form onSubmit={handleSubmit(onSubmit)} className='fields'>
                    <Field
                        value={username}
                        label={t.username}
                        placeholder={t.enter_username}
                        error={errors.username?.message}
                        type="text"
                        {...registerField('username')}                    
                    />
                    <Field
                        value={email}
                        label={t.email}
                        placeholder={t.enter_email}
                        error={errors.email?.message}
                        type="email"
                        {...registerField('email')}                    
                    />
                    <Field
                        value={password}
                        label={t.password}
                        placeholder={t.enter_password}
                        error={errors.password?.message}
                        type="password"
                        {...registerField('password')}                    
                    />
                    
                    <MainButton text={t.signup} type="submit" />
                </form>

                <div className="links">
                    <p>{t.already_have_account} <Link to="/login">{t.login}</Link></p>
                    <Link to="/terms">{t.terms_of_service}</Link>
                </div>

                <Toaster 
                    position="bottom-center"
                    toastOptions={{
                        duration: 2000,
                    }}
                />
            </div>
        </div>
    );
};

export default Register; 